import { array } from '@ember/helper';
import { action } from '@ember/object';
import { later } from '@ember/runloop';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import joinClasses from 'webapp/helpers/join-classes';
import didUpdate from 'webapp/modifiers/did-update';

export default class SaveIndicatorComponent extends Component {
	@service('request-queue') declare requestQueueService: Service.RequestQueue;

	@tracked isHidden = true;

	get requestInProgress(): boolean {
		return this.requestQueueService.isRequestInProgress;
	}

	get extraClasses(): string {
		const classes: string[] = [];
		if (this.requestInProgress) {
			classes.push('animate');
		} else if (this.isHidden) {
			classes.push('hidden');
		}
		return classes.join(' ');
	}

	@action
	checkToHide() {
		// hide slightly after requests have ended
		if (this.requestInProgress) {
			this.isHidden = false;
		} else {
			later(() => {
				this.isHidden = true;
			}, 1000);
		}
	}
	<template>
		<div
			class={{joinClasses (array "saveIndicator" this.extraClasses)}}
			{{didUpdate this.checkToHide this.requestInProgress}}
		>
			<ul>
				<li>
					<svg viewBox="-10 -10 220 220">
						<g fill="none" stroke-width="6" transform="translate(100,100)">
							<path d="M 0,-100 A 100,100 0 0,1 86.6,-50" />
							<path d="M 86.6,-50 A 100,100 0 0,1 86.6,50" />
							<path d="M 86.6,50 A 100,100 0 0,1 0,100" />
							<path d="M 0,100 A 100,100 0 0,1 -86.6,50" />
							<path d="M -86.6,50 A 100,100 0 0,1 -86.6,-50" />
							<path d="M -86.6,-50 A 100,100 0 0,1 0,-100" />
						</g>
					</svg>
					<svg viewBox="-10 -10 220 220">
						<path
							d="M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z"
							stroke-dashoffset="629"
						></path>
					</svg>
				</li>
			</ul>
		</div>
	</template>
}
